import React from 'react';

const Spinner = ({spinner, container}) => {
  return (
    <div className={`spinner-container ${container || 'h-8 w-8'}`}>
      <div className={`spinner ${spinner || 'h-5 w-5'}`}></div>
    </div>
  );
}

export default Spinner;
